export default __webpack_public_path__ + "static/media/thumb_tos.034f981a.png";